import React from "react";
import { Users, MessageSquare, Lightbulb } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";


interface KPICardsProps {
  dashboardData?: {
    faqCount: number;
    tipsCount: number;
    activeServiceCenterCount: number;
    faqCategoryCounts: Record<string, number>;
  };
}

export const KPICards = ({ dashboardData }: KPICardsProps) => {
  if (!dashboardData) return null;

  const activeCategoriesCount = Object.keys(dashboardData.activeServiceCenterCount || {});

  const contentStats = [
    {
      title: "Total FAQs",
      count: dashboardData?.faqCount,
      trend: 12, // percentage change
      icon: <MessageSquare className="text-muted-foreground" />
    },
    {
      title: "Total Tips",
      count: dashboardData?.tipsCount,
      trend: 8, // percentage change
      icon: <Lightbulb className="text-muted-foreground" />
    },
    {
      title: "Active Categories",
      count: dashboardData?.activeServiceCenterCount,
      trend: 0, // neutral change
      trendSummary: "FAQ categories",
      icon: <Users className="text-muted-foreground" />
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {contentStats.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trend={stat.trend}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};